import { render, staticRenderFns } from "./PopupAddDynamicForm.vue?vue&type=template&id=515db50a&scoped=true&"
import script from "./PopupAddDynamicForm.vue?vue&type=script&lang=js&"
export * from "./PopupAddDynamicForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515db50a",
  null
  
)

export default component.exports